/* eslint-disable indent */

<template>
  <div class="loading-wrap" v-if="isLoading">
    <md-progress-spinner
      :md-diameter="100"
      :md-stroke="10"
      class="md-accent"
      md-mode="indeterminate"
    ></md-progress-spinner>
    <!-- {{refCount}} -->
  </div>
</template>

<script>
import AuthService from "../authService.js";

export default {
  name: "LoginPage",
  props: {
    msg: String,
  },
  data: function() {
    return {
      l_code: "lana",
      l_lastname: "zzz",
      auth: new AuthService(),
      signedIn: null,
      isLoading: false,
    };
  },
  methods: {
    login: function(code, lastname) {
      // console.log(" AuthService", this.auth);
      // this.auth.getUser();
      // console.log("this.auth.getUser();" ,this.auth.getUser())
      // this.$store.dispatch("login", { code: code, lastname: lastname });
      // this.$router.push("/content/landing");
    },
  },
  async mounted() {
    console.log(this.auth);
    console.log(this.$route.params);
    if (this.$route.params.token) {
      let token = this.$route.params.token;
      this.isLoading = true;
      localStorage.setItem("token", this.$route.params.token);
      this.auth.startSigninClient(this.$route.params.token);
    } else {
      console.log("reg auth without token");
      const signIn = await this.auth.getUser();
      if (signIn) {
        await this.$store.dispatch("getPaymentMethods");
        this.$router.push("/content/landing").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        await this.auth.getUser();
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.form .form__btn {
  color: #fff !important;
}
.btn-pink {
  min-width: 100% !important;
}
</style>
